<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container-fluid">
          <GridRow>
            <div
              style="height: 95% !important;"
              class="auth-cover bottom-0 top-0 text-center col-6 d-lg-flex d-none m-4 h-100 p-0 position-absolute start-0 justify-content-center flex-column overflow-hidden rounded-3"
            >
              <img class="auth-cover__bg" style="object-fit: cover;" v-lazy="require('@/assets/img/login-img.png')" alt="">
              <div class="auth-cover__logos">
                  <div class="w-25">
                    <img v-lazy="require('@/assets/img/Logo-KPI-BSB-Final.png')" alt="Bank Sumselbabel" class="img-responsive w-100 h-auto">
                  </div>
                  <div style="display: flex;">
                    <div>
                      <img v-lazy="require('@/assets/img/logo-bank-sumselbabel-color.png')" alt="Bank Sumselbabel" class="img-responsive w-100">
                    </div>
                    <div>
                      <img v-lazy="require('@/assets/img/logo-bank-sumselbabel-syariah-color.png')" alt="Bank Sumselbabel" class="img-responsive w-100">
                    </div>
                  </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 justify-content-center flex-column">
            </div>
            <div
              class="top-0 my-auto text-center col-12 col-md-12 col-lg-6 d-lg-flex h-100 pe-0 justify-content-center flex-column">
              <div class="top-0 my-auto text-center col-12 col-md-12 col-lg-6 d-lg-flex h-100 pe-0 justify-content-center flex-column mx-auto">
                <router-view></router-view>
              </div>
            </div>
          </GridRow>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import AuthApi from "@/repository/api/AuthApi";
import GridRow from "@/components/grid/GridRow.vue";
const body = document.getElementsByTagName("body")[0];

export default {
  name: "signin",
  components: {
    GridRow,
  },
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
    }
  },
  async mounted() {
    await this.getSessionUser();
  },
  methods: {
    async login() {
      await AuthApi.login(this.form).then(async (response) => {
        await localStorage.setItem("token", response.data.token);
        window.location.reload();
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: error.response.data.message,
        });
      })
    }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>


<style scoped>
.auth-cover__bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: relative;
}

.auth-cover__logos {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  width: 100%;
  top: 0;
  left: 0;
}
.auth-cover__logos img {
  max-width: auto !important;
  height: 72px;
}
</style>